import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_STUDENT, CHANGE_STUDENT } from './constants';
import {
  loadStudentSuccess,
  loadStudentError,
  changeStudentSuccess,
  changeStudentError,
} from './actions';

// utils
import requestWrapper from 'utils/requestWrapper';
import _local from 'utils/localStorageUtils';
import api from 'utils/api';
const { endpoint } = api;


export function* loadStudent(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { id } = action;

    // we get the campaigns linked to the student
    const itemData = yield requestWrapper(
      'GET',
      endpoint?.students?.single(id),
      '',
      currentUser.token
    );

    if (!id && !itemData) {
      yield put(loadStudentSuccess(false));
    } else {
      yield put(loadStudentSuccess(itemData));
    }
  } catch (error) {
    yield put(loadStudentError(error));
  }
}

// Update for Single Student
export function* changeStudent(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { itemData } = action;

    let changedItem = false,
      isNew = !itemData?._id;

    if (isNew) {
      changedItem = yield requestWrapper(
        'POST',
        endpoint?.students?.new,
        itemData,
        token,
      );
    } else {
      changedItem = yield requestWrapper(
        'PATCH',
        endpoint?.students?.update,
        itemData,
        currentUser.token
      );
    }

    if (!changedItem) {
      yield put(changeStudentSuccess(false));
    } else {
      yield put(changeStudentSuccess(changedItem));
    }
  } catch (err) {
    yield put(changeStudentError(true));
  }
}

// Individual exports for testing
export default function* studentsDetailSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_STUDENT, loadStudent);
  yield takeLatest(CHANGE_STUDENT, changeStudent);
}
